var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"servicePage-main"},[_c('SiteTop',{on:{"changeNavSubItemIndex":_vm.changeNavMenu}}),_c('productChild',{attrs:{"navSubItemIndex":_vm.productChild.navSubItemIndex}}),_c('site-foot')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }